import { organisation, partners } from '../../data/mockData';

export default function Accreditation() {
  return (
    <section className="border-y border-canvas-300/70 bg-white">
      <div className="container py-10">
        <div className="flex flex-col items-center gap-8 lg:flex-row lg:justify-between">
          <div className="flex items-center gap-4 text-center lg:text-left">
            <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-50 text-brand-700 sm:flex">
              <svg
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M12 2 4 6v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10V6Z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </span>
            <p className="text-sm leading-relaxed text-brand-900/70">
              Accredited by{' '}
              <span className="font-bold text-brand-950">
                {organisation.accreditationBody}
              </span>{' '}
              since {organisation.accreditedSince}
              <span className="mx-2 hidden text-canvas-300 sm:inline">|</span>
              <br className="sm:hidden" />
              <span className="font-semibold text-brand-800">
                {organisation.accreditationNumber}
              </span>
            </p>
          </div>

          <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {partners.slice(0, 6).map((partner) => (
              <li
                key={partner.id}
                className="text-sm font-bold uppercase tracking-wide text-brand-900/35"
              >
                {partner.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
